import { useEffect, useState } from "react";
import {
  ArrowLeft,
  ArrowUpRight,
  Check,
  ShoppingBag,
  Wrench,
} from "lucide-react";
import { Link, useParams } from "react-router-dom";
import ProductCard from "../components/ProductCard";
import ProductImage from "../components/ProductImage";
import { useCart } from "../lib/cart";
import { db } from "../lib/data";
export default function ProductPage() {
  const { slug } = useParams(),
    [p, setP] = useState(null),
    [related, setRelated] = useState([]),
    [active, setActive] = useState(0);
  const { addItem } = useCart();
  useEffect(() => {
    db.product(slug).then(async (x) => {
      setP(x);
      if (x?.category_id)
        setRelated(
          (
            await db.products({
              category: x.category_id,
              status: "active",
              limit: 8,
            })
          )
            .filter((y) => y.id !== x.id)
            .slice(0, 4),
        );
    });
  }, [slug]);
  if (!p)
    return (
      <section className="page">
        <div className="page-title">
          <span>Product</span>
          <h1>Loading…</h1>
        </div>
      </section>
    );
  const imgs = (p.product_images || []).sort(
      (a, b) => a.sort_order - b.sort_order,
    ),
    view = { ...p, product_images: imgs[active] ? [imgs[active]] : imgs };
  return (
    <>
      <section className="product-detail page">
        <Link className="back" to="/shop">
          <ArrowLeft size={15} /> Back to products
        </Link>
        <div className="detail-grid">
          <div className="gallery">
            <ProductImage product={view} large />
            {imgs.length > 1 && (
              <div className="thumbs">
                {imgs.map((im, i) => (
                  <button
                    key={im.id}
                    className={active === i ? "active" : ""}
                    onClick={() => setActive(i)}
                  >
                    <img
                      src={
                        im.storage_path.startsWith("http")
                          ? im.storage_path
                          : `/assets/images/${im.storage_path}`
                      }
                      alt={im.alt_text || p.name}
                    />
                  </button>
                ))}
              </div>
            )}
          </div>
          <div className="detail-info">
            <span className="eyebrow">
              {p.categories?.name || p.category_id}
            </span>
            <h1>{p.display_name || p.name}</h1>
            <div className="product-code">Model: {p.sku}</div>
            {p.retail_price != null && (
              <div className="detail-price">
                ₹{Number(p.retail_price).toLocaleString("en-IN")}{" "}
                <small>MRP</small>
              </div>
            )}
            <p className="detail-description">
              {p.description || p.short_description}
            </p>
            <div className="detail-rule" />
            <div className="detail-note">
              <b>Sold individually.</b>
              <span>
                Wholesale packing quantities are not retail order quantities.
              </span>
            </div>
            <div className="product-actions">
              <button className="outline-btn" onClick={() => addItem(p)}>
                <ShoppingBag size={16} /> Add to cart
              </button>
              <Link
                className="outline-btn"
                to={`/contact?product=${encodeURIComponent(p.name)}`}
              >
                <ArrowUpRight size={16} /> Enquire
              </Link>
            </div>
            <div className="service-callout">
              <Wrench size={17} />
              <div>
                <b>Need home service?</b>
                <span>
                  Raise installation, repair and warranty tickets from your
                  account.
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="product-information page">
        <div className="section-head">
          <h2>Technical details.</h2>
          <p>{p.feature_based_name}</p>
        </div>
        <div className="spec-grid">
          <div>
            <span>Category</span>
            <b>{p.categories?.name}</b>
          </div>
          <div>
            <span>Model</span>
            <b>{p.sku}</b>
          </div>
          <div>
            <span>Warranty</span>
            <b>
              <Check size={14} />{" "}
              {p.warranty_months
                ? `${p.warranty_months} months`
                : "Refer to terms"}
            </b>
          </div>
          <div>
            <span>Retail unit</span>
            <b>1 piece</b>
          </div>
          {Object.entries(p.specifications || {})
            .filter(([k, v]) => v && k !== "colors")
            .slice(0, 8)
            .map(([k, v]) => (
              <div key={k}>
                <span>{k.replace(/([A-Z])/g, " $1")}</span>
                <b>{Array.isArray(v) ? v.join(", ") : String(v)}</b>
              </div>
            ))}
        </div>
      </section>
      {related.length > 0 && (
        <section className="related page">
          <div className="section-head">
            <h2>More from this collection</h2>
          </div>
          <div className="related-grid">
            {related.map((x) => (
              <ProductCard key={x.id} product={x} />
            ))}
          </div>
        </section>
      )}
    </>
  );
}
